import ApiCallObservable from "../../../Admin/state/mobx/common/ApiCallObservable";
import FirebaseFunctionsService from "src/services/firebase/functions/FirebaseFunctionsService";
import {IGeneratePlaidAssetReportFuncParams} from "shared/functions/generatePlaidAssetReport";

export class BankConnectionStore extends ApiCallObservable {

    public sendPlaidData = async (params: IGeneratePlaidAssetReportFuncParams) => {
            return FirebaseFunctionsService.generatePlaidAssetReport(params);
    }
}


// WEBPACK FOOTER //
// ./src/scenes/Forms/state/mobx/BankConnectionStore.ts